// eslint-disable-next-line
// @ts-nocheck
import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import { setUser } from '../../store/state/authSlice';
import { useFindUserByIdMutation } from '../../store/api/userApi';
import { Box } from '@mui/system';
import { CircularProgress } from '@mui/material';
import { useAppDispatch } from '../../store/hooks';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const [findUserById, responseUser] = useFindUserByIdMutation();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (token) {
      findUserById({ id: token.userId, token: token.token });
    }
  }, []);

  useEffect(() => {
    if (responseUser.isSuccess) {
      dispatch(
        setUser({
          data: responseUser.data,
          token: token.token,
          userType: token.userType,
        })
      );
    }
  }, [responseUser.isSuccess]);

  return responseUser.isLoading ? (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <CircularProgress />
    </Box>
  ) : (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle>{token ? <Outlet /> : <Navigate to="/login" replace />}</MainStyle>
    </RootStyle>
  );
}
